import React from 'react';
import { Link } from 'react-router-dom';
import SubPage from '../components/site/SubPage';
import { PageSection } from '../components/site/SubPageParts';

const NotFound = () => (
  <SubPage title="Page not found">
    <PageSection className="pt-10 pb-6">
      <div className="border border-black/25 px-6 py-14 text-center md:py-20">
        <p className="text-[46px] font-bold leading-none text-black md:text-[76px]">404</p>
        <h1 className="mt-4 text-[22px] font-bold text-black md:text-[28px]">
          We couldn&rsquo;t find that page.
        </h1>
        <p className="mx-auto mt-3 max-w-[46ch] text-[15px] leading-relaxed text-black md:text-[17px]">
          The link may be out of date, or the page may have moved.
        </p>
        <Link
          to="/"
          className="mt-8 inline-block rounded-[8px] bg-[#2F5F9E] px-8 py-3 text-[16px] text-white transition-colors hover:bg-[#27508a] md:text-[18px]"
        >
          Back to home
        </Link>
      </div>
    </PageSection>
  </SubPage>
);

export default NotFound;
